import { type FC } from 'react'
import { deepEquals, enumOptionsIndexForValue, enumOptionsValueForIndex, type WidgetProps } from '@rjsf/utils'
import { SelectDropdown } from '../../../../SelectDropdown/SelectDropdown'
import { fieldNameOf, requiredLabel } from '../displayLabel'
import { useExcludedOptionValues } from '../excludedOptions'
import { CheckboxGroupWidget } from './CheckboxGroupWidget'

const SEARCHABLE_OPTION_COUNT = 8

export const SelectWidget: FC<WidgetProps> = (props) => {
  const { id, label, value, options, schema, placeholder, required, disabled, readonly, multiple, onChange } = props
  const excluded = useExcludedOptionValues(id)
  const enumOptions = options.enumOptions ?? []
  const enumDisabled: unknown[] = Array.isArray(options.enumDisabled) ? options.enumDisabled : []
  if (multiple) {
    return <CheckboxGroupWidget {...props} />
  }

  const selectOptions = enumOptions
    .map((option, index) => ({ id: String(index), label: option.label, value: option.value }))
    .filter((option) => !enumDisabled.some((disabledValue) => deepEquals(disabledValue, option.value)))
    .filter((option) => deepEquals(option.value, value) || !excluded.some((used) => deepEquals(used, option.value)))
    .map((option) => ({ id: option.id, label: option.label }))
  const selectedIndex = enumOptionsIndexForValue(value, enumOptions)
  const selectedOption = typeof selectedIndex === 'string' ? (selectOptions.find((option) => option.id === selectedIndex) ?? null) : null

  return (
    <SelectDropdown
      options={selectOptions}
      initialSelectedOption={selectedOption}
      searchable={selectOptions.length > SEARCHABLE_OPTION_COUNT}
      disabled={disabled || readonly}
      placeholder={placeholder || 'Select…'}
      showDeselectOption={!required}
      onDeselect={() => onChange(options.emptyValue)}
      onOptionSelected={(option) => onChange(enumOptionsValueForIndex(option.id, enumOptions, options.emptyValue))}
      ariaLabel={requiredLabel(fieldNameOf(id, label, schema, options.listItem), required)}
      toggleId={id}
    />
  )
}
